<template>
  <avs-chip
    class="min-width-120"
    color="error"
    icon="mdi-alert-outline"
    iconColor="white"
    text-color="white"
  >
    {{ $t("commons.status.overdue") }}
  </avs-chip>
</template>

<script>
export default {
  name: "OverdueChip"
}
</script>
